import {
  type UndoHeatmapData,
  type UndoItemType,
} from '~/_shared/types/undo/undoItem';
import { getHeatMapPresetColor } from '~/heatMap/panel/heatMapPanel.helpers';
import { type UNDO_MODEL_VERSIONS } from '../undo.constants';

export type AllHeatmapVersions = typeof UNDO_MODEL_VERSIONS[UndoItemType.REMOVE_HEATMAP][number];

const undoHeatmapDataFromAnyVersionToCurrentVersionConverters: {
  [key in AllHeatmapVersions]: (anyVersionUndoData: any) => UndoHeatmapData
} = {
  ['1']: (undoData) => {
    const backupColors = getHeatMapPresetColor([]);
    const convertedToNew = {
      ...undoData,
      colors: [
        undoData.lightColor || backupColors.colors[2],
        undoData.mediumColor || backupColors.colors[3],
        undoData.denseColor || backupColors.colors[4],
      ],
    };
    delete convertedToNew.denseColor;
    delete convertedToNew.lightColor;
    delete convertedToNew.mediumColor;

    return convertedToNew as UndoHeatmapData;
  },
  ['2']: (undoData) => undoData as UndoHeatmapData,
};

export const convertUndoHeatmapDataAnyVersionToCurrent = (
  anyVersionUndoData: any,
  version: AllHeatmapVersions,
): UndoHeatmapData => (
  undoHeatmapDataFromAnyVersionToCurrentVersionConverters[version](anyVersionUndoData)
);
